module.exports = __webpack_public_path__ + "img/bsjg_03.e402e90c.png";